import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";
const API_URL = `${API_URL_COMMON}`;
const INSIGHTS_URL = `${API_URL_COMMON}/api/insights/stampcards`;
// const INSIGHTS_URL = "https://insights-sa.parktechnology.com/v1/stampcards";

class AccountService {
  getAccStatus(accUrn) {
    return axios({
      method: "get",
      url: `${API_URL}/accounts/${accUrn}/account-status`,
      headers: authHeader(),
    });
  }

  getUserAccounts() {
    return axios({
      method: "get",
      url: `${API_URL}/accounts/user-accounts`,
      headers: authHeader(),
    });
  }

  createBusiness(account_urn, businessData) {
    return axios({
      method: "post",
      url: `${API_URL}/businesses/with-logo`,
      data: businessData,
      headers: authHeader("multipart/form-data", { account_urn: account_urn }),
    });
  }

  getBusiness(account_urn) {
    const config = {
      method: "get",
      url: `${API_URL}/businesses`,
      headers: authHeader("", { account_urn }),
    };
    return axios(config); // Send the request
  }

  createOutlet(outletData, businessUrn) {
    return axios({
      method: "post",
      url: `${API_URL}/businesses/${businessUrn}/outlets`,
      data: outletData,
      headers: authHeader(),
    });
  }

  getOutlets(businessUrn) {
    if (businessUrn) {
      return axios({
        method: "get",
        url: `${API_URL}/businesses/${businessUrn}/outlets`,
        headers: authHeader(),
      });
    }
  }

  updateOutlet({ businessUrn, outletUrn, data }) {
    if (businessUrn) {
      return axios({
        method: "post",
        url: `${API_URL}/businesses/${businessUrn}/outlets/${outletUrn}/update`,
        headers: authHeader(),
        data,
      });
    }
  }

  deleteOutlet({ businessUrn, outletUrn }) {
    if (businessUrn) {
      return axios({
        method: "delete",
        url: `${API_URL}/businesses/${businessUrn}/outlets/${outletUrn}/update`,
        headers: authHeader(),
      });
    }
  }

  deleteStampCode({ businessUrn, outletUrn, stampCode }) {
    if (businessUrn) {
      return axios({
        method: "delete",
        url: `${API_URL}/businesses/${businessUrn}/outlets/${outletUrn}/stamp_codes/${stampCode}`,
        headers: authHeader(),
      });
    }
  }

  uploadVoucherAssets(accUrn, data) {
    if (accUrn) {
      return axios({
        method: "post",
        url: `${API_URL}/stamp-cards/upload-assets/vouchers`,
        headers: authHeader("multipart/form-data", {
          account_urn: accUrn,
        }),
        data: data,
      });
    }
  }

  uploadAssets(accUrn, data) {
    if (accUrn) {
      return axios({
        method: "post",
        url: `${API_URL}/stamp-cards/upload-assets/stampcard-all`,
        headers: authHeader("multipart/form-data", {
          account_urn: accUrn,
        }),
        data: data,
      });
    }
  }

  createStampCard(accUrn, data) {
    if (accUrn) {
      const requestConfig = {
        method: "post",
        url: `${API_URL}/stamp-cards`,
        headers: authHeader("application/json", {
          account_urn: accUrn,
        }),
        data,
      };
      return axios(requestConfig);
    }
  }

  getRewards(businessUrn) {
    if (businessUrn) {
      return axios({
        method: "get",
        url: `${API_URL}/reward-type/${businessUrn}`,
        headers: authHeader(),
      });
    }
  }

  getStampcards(businessUrn, accUrn) {
    if (businessUrn) {
      return axios({
        method: "get",
        headers: authHeader(null, {
          account_urn: accUrn,
        }),
        url: `${API_URL}/stamp-cards`,
        params: { businessUrn: businessUrn },
      });
    }
  }

  uploadProductImage(imageData) {
    return axios({
      method: "post",
      url: `${API_URL}/uploads/`,
      data: imageData,
      headers: authHeader("multipart/form-data", null),
    });
  }

  createProduct(productData) {
    return axios({
      method: "post",
      headers: authHeader(),
      url: `${API_URL}/products`,
      data: productData,
    });
  }

  getAllProducts() {
    const params = {
      page: 1,
      limit: 30,
      searchKey: "",
    };

    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/products`,
      params: params,
    });
  }

  getAllProductsbyBusiness(business_slug) {
    const params = {
      page: 1,
      limit: 30,
      searchKey: "",
    };

    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/products/by_business/${business_slug}`,
      params: params,
    });
  }

  getProduct(productId) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/products/${productId}`,
    });
  }

  updateProduct(productId, productData) {
    return axios({
      method: "put",
      headers: authHeader(),
      url: `${API_URL}/products/${productId}`,
      data: productData,
    });
  }

  deleteProduct(productId) {
    return axios({
      method: "delete",
      headers: authHeader(),
      url: `${API_URL}/products/${productId}`,
    });
  }

  getSchemas(businessUrn, type) {
    let params;
    if (type) {
      params = { businessUrn: businessUrn, type: type };
    } else {
      params = { businessUrn: businessUrn };
    }
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/businesses/schemes`,
      params: params,
    });
  }

  createMagiccode(accUrn, data) {
    return axios({
      method: "post",
      headers: authHeader(null, {
        account_urn: accUrn,
      }),
      url: `${API_URL}/magic-codes`,
      data: data,
    });
  }

  getMagiccodes(accUrn) {
    return axios({
      method: "get",
      headers: authHeader(null, {
        account_urn: accUrn,
      }),
      url: `${API_URL}/magic-codes`,
    });
  }

  createCampaign(data) {
    return axios({
      method: "post",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns`,
      data: data,
    });
  }

  getAllCampaigns() {
    const params = { limit: 100, page: 1 };
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns`,
      params: params,
    });
  }

  getCampaign(id) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns/${id}`,
    });
  }

  updateCampaign(id, data) {
    return axios({
      method: "put",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns/${id}`,
      data: data,
    });
  }

  deleteCampaign(id) {
    return axios({
      method: "delete",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns/${id}`,
    });
  }

  addStampCode(outletUrn, businessUrn, data) {
    return axios({
      method: "post",
      headers: authHeader(),
      url: `${API_URL}/businesses/${businessUrn}/outlets/${outletUrn}/stamp_codes`,
      data: data,
    });
  }

  deleteStampcard({ cardUrn, accUrn }) {
    return axios({
      method: "delete",
      headers: authHeader("", { account_urn: accUrn }),
      url: `${API_URL}/stamp-cards/${cardUrn}/delete`,
    });
  }

  getMembers(accUrn) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `https://magic-sa-api.parktechnology.com/v1/account/${accUrn}/members/`,
    });
  }

  sendInvite(data) {
    const inviteData = {
      ...data,
      invitedBy: JSON.parse(localStorage.getItem("authData"))?.user_urn,
    };
    return axios({
      method: "post",
      headers: authHeader(),
      url: `${API_URL}/invites/invite`,
      data: inviteData,
    });
  }

  getInsightsHeadline(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/headlines`,
      params: params,
    });
  }

  getInsightsAwardedRedeemed(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/rewards-awarded-redeemed-over-time`,
      params: params,
    });
  }
  getInsightsVisitAvgByWeek(params) {
    return axios({
      method: "get",

      headers: authHeader(),
      url: `${INSIGHTS_URL}/visit-avg-by-week`,
      params: params,
    });
  }

  getInsightsStampTotDist(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/stamp-total-distribution`,
      params: params,
    });
  }

  getInsightsSampsOverTimeByOutlet(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/stamps-over-time-by-outlet`,
      params: params,
    });
  }

  getAllRewards(businessUrn) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/reward-type/${businessUrn}`,
    });
  }

  createReward(data) {
    return axios({
      method: "post",
      headers: authHeader(),
      url: `${API_URL}/reward-type`,
      data,
    });
  }

  campaignAccept(campaignId) {
    return axios({
      method: "put",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns/${campaignId}/accept`,
      data: {
        is_active: true,
      },
    });
  }

  campaignReject(campaignId) {
    return axios({
      method: "put",
      headers: authHeader(),
      url: `${API_URL}/api/campaigns/${campaignId}/reject`,
      data: {
        is_active: false,
      },
    });
  }

  toggleBusinessStatus(accUrn, data) {
    return axios({
      method: "put",
      headers: authHeader(null, {
        account_urn: accUrn,
      }),
      url: `${API_URL}/businesses/hide-or-live`,
      data: data,
    });
  }

  setManualBusinessStatus(data) {
    return axios({
      method: "put",
      headers: authHeader(),
      url: `${API_URL}/businesses/manual-status`,
      data,
    });
  }

  getAllBusinesses(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/businesses/portal`,
      params,
    });
  }

  getAllAccounts(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/accounts/all`,
      params,
    });
  }

  // Update an account (edit)
  editUserAcc(urn, data) {
    return axios({
      method: "put",
      headers: authHeader(),
      url: `${API_URL}/accounts/${urn}/update`,
      data,
    });
  }

  // Delete an account
  deleteUserAcc(urn) {
    return axios({
      method: "delete",
      headers: authHeader(),
      url: `${API_URL}/accounts/${urn}/delete`,
    });
  }

  getStripeAcc(accUrn) {
    return axios({
      method: "get",
      url: `${API_URL_COMMON}/payment-onboarding/${accUrn}/account`,
      headers: authHeader(),
    });
  }

  getStripeCountries() {
    return axios({
      method: "get",
      url: `${API_URL_COMMON}/payment-onboarding/countries`,
      headers: authHeader(),
    });
  }

  createStripeAcc(data) {
    return axios({
      method: "post",
      url: `${API_URL_COMMON}/payment-onboarding/create-account`,
      headers: authHeader(),
      data,
    });
  }

  createStripeAccLink(data) {
    return axios({
      method: "post",
      url: `${API_URL_COMMON}/payment-onboarding/create-account-link`,
      headers: authHeader(),
      data,
    });
  }

  getAllOutlets(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/operations/outlets`,
      params,
    });
  }

  approveOutlet(urn) {
    return axios({
      method: "patch",
      headers: authHeader(),
      url: `${API_URL}/operations/outlets/${urn}/approve`,
    });
  }

  rejectOutlet(urn) {
    return axios({
      method: "patch",
      headers: authHeader(),
      url: `${API_URL}/operations/outlets/${urn}/reject`,
    });
  }

  getAllStampcards(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/operations/stamp-cards`,
      params,
    });
  }

  approveStampcard(urn) {
    return axios({
      method: "patch",
      headers: authHeader(),
      url: `${API_URL}/operations/stamp-cards/${urn}/approve`,
    });
  }

  rejectStampcard(urn) {
    return axios({
      method: "patch",
      headers: authHeader(),
      url: `${API_URL}/operations/stamp-cards/${urn}/reject`,
    });
  }

  exportInsights(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/export`,
      params: params,
      responseType: "blob",
    });
  }

  getRewardsAwardedRedeemedOverTimeByOutlet(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/rewards-awarded-redeemed-over-time-by-outlet`,
      params: params,
    });
  }

  rewardsAwardedRedeemedOverTimeByOutlet(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/rewards-awarded-redeemed-over-time-by-outlet`,
      params: params,
    });
  }

  exportInsightsAwardedRedeemedOverTimeByOutlet(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${INSIGHTS_URL}/export-rewards-awarded-redeemed-over-time-by-outlet`,
      params: params,
    });
  }

  getPayoutsHistory(accUrn) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/payouts/ledger/${accUrn}/history`,
    });
  }

  getPayoutsBalance(accUrn) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/payouts/ledger/${accUrn}`,
    });
  }

  addPayout(data) {
    return axios({
      method: "post",
      headers: authHeader(),
      url: `${API_URL}/payouts/force-clear`,
      data,
    });
  }

  getPayouts(params) {
    return axios({
      method: "get",
      headers: authHeader(),
      url: `${API_URL}/payouts/ledger`,
      params,
    });
  }
}

const accountService = new AccountService();

export default accountService;
